import { isTruthy } from 'shared/utils/misc';
/**
 * Get both third party and internal tracking values. Note that
 * third party tracking should have already had their `value`
 * filtered, so only the best match will be present. And internal
 * tracking will only ever have a single value.
 */
export const getTrackingValues = (trackingType, symbolId) => {
    var _a, _b;
    const thirdParty = filterTrackingFields(trackingType, symbolId, (_a = window.ADAPT) === null || _a === void 0 ? void 0 : _a.thirdPartyTracking);
    const internal = filterTrackingFields(trackingType, symbolId, (_b = window.ADAPT) === null || _b === void 0 ? void 0 : _b.internalTracking);
    return [thirdParty, internal].filter(isTruthy);
};
const filterTrackingFields = (trackingType, symbolId, trackingFields) => {
    var _a, _b, _c;
    const value = (_b = (_a = trackingFields) === null || _a === void 0 ? void 0 : _a.find(f => f.type === trackingType && f.key === symbolId)) === null || _b === void 0 ? void 0 : _b.value;
    return (_c = value) === null || _c === void 0 ? void 0 : _c[0];
};
/**
 * Gets the click tracking for a Symbol. If it is a Carousel slide,
 * it is pulled from the Carousel's tracking config. Otherwise, it
 * is pulled from the click-tracking config directly attached to the Symbol.
 */
export const getClickTracking = (symbolId) => getClickTrackingForSlide(symbolId) || getTrackingValues('click', symbolId);
/**
 * Get click tracking for a specific slide. Returns `undefined`
 * if not slide-specific click tracking is set up.
 */
const getClickTrackingForSlide = (slideSymbolId) => {
    var _a, _b;
    // Note: window.ADAPT may exist, even if window.ADAPT.ad
    // doesn't, because of `setUTMOverrides()`.
    const symbols = ((_b = (_a = window.ADAPT) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.symbols) || {};
    const carouselParent = Object.values(symbols).find(possibleParent => possibleParent.type === 'carousel' &&
        possibleParent.children.includes(slideSymbolId));
    if (!carouselParent) {
        return undefined;
    }
    const childIdx = carouselParent.children.indexOf(slideSymbolId);
    const slideIdx = `slide${childIdx + 1}`;
    const clickTracking = getTrackingValues('carousel', carouselParent.id)
        .map(v => v.slideClick[slideIdx])
        .filter(isTruthy)
        .map(v => {
        return typeof v === 'string' ? { url: v, isParallel: false } : v;
    });
    return clickTracking.length > 0 ? clickTracking : undefined;
};
